import { atom, useAtom } from 'jotai';

export const userToEdit = atom(undefined);

export function useUserToEditAtom() {
  return useAtom(userToEdit);
}
